import { Record, List } from 'immutable';
export default Record({
  staticDateAnchor: null,
  contactPropertyAnchor: null,
  errors: List(),
  warnings: List(),
  info: List()
});